import { useState, useEffect } from 'react';

export default function Hero() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleExplore = () => {
    const categorySection = document.getElementById('categories');
    categorySection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="relative min-h-screen">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/6411cc55962b648150ee0b773fbca236.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/45"></div>
      </div>

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-5 flex items-center justify-between">
          <div className={`text-2xl font-bold transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
            TechInsight
          </div>
          <div className="hidden md:flex items-center gap-8">
            <a href="#" className={`transition-colors cursor-pointer font-medium text-sm ${isScrolled ? 'text-gray-700 hover:text-cyan-600' : 'text-white/90 hover:text-white'}`}>Home</a>
            <a href="#" className={`transition-colors cursor-pointer font-medium text-sm ${isScrolled ? 'text-gray-700 hover:text-cyan-600' : 'text-white/90 hover:text-white'}`}>Articles</a>
            <a href="#" className={`transition-colors cursor-pointer font-medium text-sm ${isScrolled ? 'text-gray-700 hover:text-cyan-600' : 'text-white/90 hover:text-white'}`}>Categories</a>
            <a href="#" className={`transition-colors cursor-pointer font-medium text-sm ${isScrolled ? 'text-gray-700 hover:text-cyan-600' : 'text-white/90 hover:text-white'}`}>About</a>
          </div>
          <button className="px-6 py-2.5 bg-gradient-to-r from-cyan-500 to-blue-600 text-white rounded-lg hover:from-cyan-600 hover:to-blue-700 transition-all whitespace-nowrap cursor-pointer font-medium text-sm shadow-lg shadow-cyan-500/30">
            Get Started
          </button>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 pt-48 pb-40">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-white/10 backdrop-blur-md rounded-full text-white mb-8 border border-cyan-400/30 shadow-lg shadow-cyan-500/20">
            <i className="ri-rocket-line text-cyan-400"></i>
            <span className="text-sm font-semibold">Explore the Future of Tech</span>
          </div>
          
          <h1 className="text-7xl font-extrabold text-white leading-tight mb-7">
            Insights That Shape
            <br />
            Tomorrow's Technology
          </h1>
          
          <p className="text-xl text-white/95 leading-relaxed mb-12 max-w-2xl mx-auto">
            Deep dives into artificial intelligence, blockchain, quantum computing, and emerging technologies that are transforming our digital landscape.
          </p>
          
          <div className="flex items-center justify-center gap-5">
            <button 
              onClick={handleExplore}
              className="group px-9 py-4 bg-gradient-to-r from-cyan-500 to-blue-600 text-white rounded-lg hover:from-cyan-600 hover:to-blue-700 transition-all shadow-xl shadow-cyan-500/40 hover:shadow-2xl hover:shadow-cyan-500/50 whitespace-nowrap cursor-pointer flex items-center gap-3 font-semibold text-sm"
            >
              Start Reading
              <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
            </button>
            <button className="px-9 py-4 bg-white/10 backdrop-blur-md text-white rounded-lg hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer font-semibold text-sm border border-white/30">
              Watch Video
            </button>
          </div>
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mt-28 max-w-5xl mx-auto">
          <div className="text-center bg-gradient-to-br from-cyan-500/20 to-blue-600/20 backdrop-blur-md rounded-xl p-6 border border-cyan-400/30 shadow-lg shadow-cyan-500/20">
            <div className="text-5xl font-bold text-white mb-2">3.2M+</div>
            <div className="text-white/85 font-medium text-sm">Active Readers</div>
          </div>
          <div className="text-center bg-gradient-to-br from-cyan-500/20 to-blue-600/20 backdrop-blur-md rounded-xl p-6 border border-cyan-400/30 shadow-lg shadow-cyan-500/20">
            <div className="text-5xl font-bold text-white mb-2">1,850+</div>
            <div className="text-white/85 font-medium text-sm">Published Articles</div>
          </div>
          <div className="text-center bg-gradient-to-br from-cyan-500/20 to-blue-600/20 backdrop-blur-md rounded-xl p-6 border border-cyan-400/30 shadow-lg shadow-cyan-500/20">
            <div className="text-5xl font-bold text-white mb-2">75+</div>
            <div className="text-white/85 font-medium text-sm">Tech Experts</div>
          </div>
          <div className="text-center bg-gradient-to-br from-cyan-500/20 to-blue-600/20 backdrop-blur-md rounded-xl p-6 border border-cyan-400/30 shadow-lg shadow-cyan-500/20">
            <div className="text-5xl font-bold text-white mb-2">98%</div>
            <div className="text-white/85 font-medium text-sm">Satisfaction Rate</div>
          </div>
        </div>
      </div>
    </div>
  );
}
